import React from "react"
import * as styles from"./cardlist.module.scss"
import { Link, graphql, StaticQuery } from "gatsby"

// Utilities
import kebabCase from "lodash/kebabCase"
//import Img from "gatsby-image"
import getTimeToRead from "../utils/timeToRead"

const PinnedCard = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allMarkdownRemark(
            sort: { fields: [frontmatter___date], order: DESC }
            limit: 1
          ) {
            edges {
              node {
                excerpt
                fields {
                  slug
                }
                html
                frontmatter {
                  description
                  date(formatString: "MMMM DD, YYYY")
                  title
                  tags
                  description
                  coverImg
                }
                fields {
                  slug
                }
              }
            }
          }
        }
      `}
      render={data => {
        const node = data.allMarkdownRemark.edges[0].node
        const tags = node.frontmatter.tags || []
        let coverImagePath = node.frontmatter.coverImg
        return (
          <section className={`${styles.pinnedwrap} py-80`}>
            <div className={styles.blogContentPinned}>
              <div className={styles.avatarPinned}>
                <Link to={node.fields.slug} className="bs-md">
                  {coverImagePath ? (
					<img src={coverImagePath} />
                  ) : (
                    <img src="/assets/images/default.png" alt="default-img" />
                  )}
                </Link>
              </div>
              <div className={styles.descriptionPinned}>
                <div className={`${styles.tag} ${styles.pinned}`}>
                  {tags &&
                    tags.map(tag => (
                      <Link to={`/tags/${kebabCase(tag)}/`}> {tag} </Link>
                    ))}
                </div>
                <div className={styles.description}>
                  <h1>
                    <Link to={node.fields.slug}>
                      {node.frontmatter.title || node.fields.slug}
                    </Link>
                  </h1>
                  <p
                    className={`${styles.descriptiontext} ${styles.pinned}`}
                    dangerouslySetInnerHTML={{
                      __html: node.frontmatter.description || node.excerpt,
                    }}
                  />
				</div>
              </div>
            </div>
          </section>
        )
      }}
    />
  )
}

export default PinnedCard
